<div class="custom-reminder success" [class.clickable-reminder]="message?.type === 'lead'" (click)="onReminderClick($event)">
   <div class="notification-header">
    <span *ngIf="isTop" class="floating-clear-all" (click)="clearAllReminders($event)" title="Clear All"></span>

    <h6>{{ message?.type === 'lead' ? 'Follow-up Call Reminder' : 'Task Reminder' }}</h6>
    <span class="icon icon-close close-btn" (click)="closePopup($event)"></span>
  </div>
  <div class="notification-content" *ngIf="message?.type === 'lead'">
    <div class="message-line">
      <i class="icon icon-user"></i>
      <span class="message-text" [title]="message.lead_name">{{ message.lead_name }}</span>
    </div>

    <div class="meta-line">
      <div class="info-block" *ngIf="message.lead_mobile">
        <i class="icon icon-call"></i>
        {{ message.lead_mobile }}
      </div>

      <div class="divider" *ngIf="message.lead_mobile && message.lead_follow_up_time"></div>

      <div class="info-block" *ngIf="message.lead_follow_up_time">
        <i class="icon icon-clock"></i>
        {{ message.lead_follow_up_time }}
      </div>
    </div>
  </div>
    <div class="notification-content" *ngIf="message?.type !== 'lead'">
  <div class="message-line">
    <i class="icon icon-clock"></i>
    <span class="message-text" [title]="message.task_name">{{ message.task_name }}</span>
  </div>

  <div class="meta-line">
    <div class="info-block" *ngIf="message.task_time">
      <i class="icon icon-clock"></i>
      {{ message.task_time }}
    </div>

    <div class="divider" *ngIf="message.task_time && message.task_patient_name"></div>

    <div
      class="info-block clickable"
      *ngIf="message.task_patient_name"
      (click)="goToMemberDetails($event, message.patient_id, message.participation_id)"
    >
      <i class="icon icon-user"></i>
      <span class="blue-text">{{ message.task_patient_name }}</span>
    </div>
  </div>
</div>
</div>
